import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPDFApply } from '../../eDocumentsSlice';

const NtsResult_03 = () => {
  const dispatch = useDispatch();
  const { ntsResult } = useSelector(state => state.eDocuments);

  useEffect(() => {
    dispatch(getPDFApply({ htmPCd: '3' }));
  }, []);

  return (
    <div className="yearendManualContentsBox">
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>인원별 합계</p>
        <Table01 ntsResult={ntsResult} />
      </div>

      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>유형별 합계</p>
        <Table02 ntsResult={ntsResult} />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>교육비 입력 상세 내역</p>
        <Table03
          ntsResult={ntsResult?.list?.filter(
            item =>
              item?.htm002 &&
              item?.htm002?.indexOf('직업훈련비') === -1 &&
              item?.htm002?.indexOf('교복') === -1 &&
              item?.htm002?.indexOf('학자금대출') === -1,
          )}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>교육비 입력 상세 내역 (직업훈련비)</p>
        <Table03
          ntsResult={ntsResult?.list?.filter(
            item => item?.htm002 && item?.htm002?.indexOf('직업훈련비') !== -1,
          )}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>교육비 입력 상세 내역 (교복구입비)</p>
        <Table03
          ntsResult={ntsResult?.list?.filter(
            item => item?.htm002 && item?.htm002?.indexOf('교복') !== -1,
          )}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>
          교육비 입력 상세 내역 (학자금대출 원리금상환액)
        </p>
        <Table03
          ntsResult={ntsResult?.list?.filter(
            item => item?.htm002 && item?.htm002?.indexOf('학자금대출') !== -1,
          )}
        />
      </div>
    </div>
  );
};

export default NtsResult_03;

const Table01 = ({ ntsResult }) => {
  const headList = [
    // { name: "순번", key: "", width: "70px" },
    { name: '성명', key: 'htmPerNm', width: '50%' },
    // { name: "주민등록번호", key: "htmRegNum", width: "233.33px" },
    { name: '합계', key: 'sum', width: '50%', align: 'right' },
  ];

  return (
    <div>
      <div className="displayFlex tableTr">
        {headList.map((item, index) => (
          <div
            className="tableTitle captionBold"
            key={index}
            style={{ borderTop: '1px solid #D9D9D9' }}>
            {item.name}
          </div>
        ))}
      </div>
      {ntsResult?.listPerSum?.map(
        (item, index) =>
          item.htmRegNum && (
            <div key={index} className="displayFlex tableTr">
              {headList.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{ justifyContent: header.align }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ),
      )}
    </div>
  );
};

const Table02 = ({ ntsResult }) => {
  const headList = [
    // { name: '순번', width: '70px' },
    { name: '유형', width: '50%', key: 'htmPerNm' },
    { name: '합계', width: '50%', key: 'sum', align: 'right' },
  ];

  return (
    <div>
      <div className="displayFlex tableTr">
        {headList.map((item, index) => (
          <div
            className="tableTitle captionBold"
            key={index}
            style={{ borderTop: '1px solid #D9D9D9' }}>
            {item.name}
          </div>
        ))}
      </div>
      {ntsResult?.listPerSum?.map(
        (item, index) =>
          item.htmRegNum == '' && (
            <div key={index} className="displayFlex tableTr">
              {headList.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{ justifyContent: header.align }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ),
      )}
    </div>
  );
};

const Table03 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '학생', width: '30%', key: 'htmPerNm' },
    { name: '학생 주민번호', width: '30%', key: 'htmRegNum' },
    { name: '교육비구분', width: '40%', key: 'htm002' },
  ];

  const headListGroup2 = [
    { name: '월', key: 'htmMm2', width: '10%' },
    { name: '학교명', width: '20%', key: 'htm004', d_width: '30%' },
    { name: '사업자번호', width: '30%', key: 'htm003' },
    { name: '납입금액', width: '40%', key: 'htm001', align: 'right' },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};
